// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FareEstimateHelper$PorterinFeature from "../../../core/helpers/FareEstimateHelper.mjs";
import * as RequirementVMMapper$PorterinFeature from "../view-model/RequirementVMMapper.mjs";
import * as FareEstimateRequirementModuleScss from "../styles/FareEstimateRequirement.module.scss";

var default_styles = FareEstimateRequirementModuleScss;

function FareEstimateReqRadioCmp(Props) {
  var requirement = Props.requirement;
  var onChange = Props.onChange;
  var checked = Props.checked;
  var disabled = Props.disabled;
  var styles = Props.styles;
  var requirement_labels = Props.requirement_labels;
  return React.createElement("label", {
              className: "" + styles["requirement-radio-button"] + " " + (
                checked ? styles.checked : ""
              ) + ""
            }, React.createElement("input", {
                  className: styles["requirement-input"],
                  checked: checked,
                  disabled: disabled,
                  name: "requirement",
                  type: "radio",
                  value: FareEstimateHelper$PorterinFeature.requirementToString(requirement),
                  onChange: onChange
                }), RequirementVMMapper$PorterinFeature.getRequirementLabel(requirement, requirement_labels));
}

var make = FareEstimateReqRadioCmp;

export {
  default_styles ,
  make ,
}
/* default_styles Not a pure module */
